<template>
	<div>
		
		<div  style="width: 100%;height: 720px;background-color: #0F0B26;color: white;">
			<div style="color:white;text-align: center;background-color: #0F0B26;font-weight: 800;">车辆进出动态</div>
			<div v-for="s in list" style="margin: 20px 0;font-size: 14px;">
				<div>{{s}}</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		props:["fwtj","isTrue"],
		data() {
			return {
				list:[]
			}
		},
		watch:{
			isTrue(val){
				if(val==true){
					this.getRcrzqs()
				}
			}
		},
		methods: {
			getRcrzqs() {
				setTimeout(() => {
					this.$http.get("/api/screen/getTodayServiceAndRepair").then(res=>{
						console.log(res)
						this.list=res.data.data
					})
					
				}, 100)
			}
		}
	}
</script>

<style scoped="scoped">
</style>
